import { Component, HostListener, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TimeUnits } from '@uigy/shared/enums/timeUnits.enum';
import { AuthService } from '@uigy/shared/services/auth.service';
import { TokenService } from '@uigy/shared/services/token.service';
import { interval, Subject, Subscription, switchMap } from 'rxjs';

@Component({
    selector: 'app-iframe',
    template: '<iframe [src]="safeUrl" hidden></iframe>',
    standalone: false
})
export class IframeComponent implements OnDestroy {
  public safeUrl?: SafeResourceUrl;
  private resetTimer: Subject<void> = new Subject<void>();

  // reload the iframe if no token received within a minute
  // reload page after 10 minutes in idle
  private reloadTimerSubscription: Subscription = this.resetTimer
    .pipe(switchMap(() => interval(TimeUnits.minute)))
    .subscribe((minutes: number) => {
      if (minutes < 9) {
        this.reloadIframe();
      } else {
        location.reload();
      }
    });

  constructor(private authService: AuthService, private sanitizer: DomSanitizer, private tokenService: TokenService) {
    this.reloadIframe();
  }

  private reloadIframe(): void {
    // Clear stored token before reloading to ensure we get a fresh token
    this.authService.clearStoredToken();
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.authService.getTokenUrl());
  }

  @HostListener('window:message', ['$event'])
  public onMessage(e: MessageEvent): void {
    if (this.tokenService.isIndegyTokenMessage(e.data)) {
      this.resetTimer.next();
      this.authService.handleAuthMessage(e.data).subscribe();
    }
  }

  ngOnDestroy(): void {
    this.resetTimer.complete();
    this.reloadTimerSubscription.unsubscribe();
  }
}
